import {StyleSheet} from 'react-native';
const getStyles = (colors: any) =>
  StyleSheet.create({
    headerText: {marginTop: 12, lineHeight: 41, fontSize: 34, color: colors.textPrimary, fontWeight: '700'},
    requirementsText: {marginTop: 16, fontSize: 19, lineHeight: 22, fontWeight: '400', color: colors.textSecondary},
  });

export default getStyles;
